<template>
	<div class="userView">
		<navBack title="证书"></navBack>
		<div class="userdetail_title">
			<p>证书</p>
			<span @click="addCert">添加</span>
		</div>
		<div class="userdetail_body" v-for="(item,index) in certList" :key="index">
			<div class="userdetail_body__view">
				<div class="userdetail_body__pspan">
					<p>{{item.cert_type_two_label}}</p>
				</div>
				<el-image style="width: 110px; height: 120px;;margin-top: 10px;" fit="cover" :src="item.cert_photo"
					:preview-src-list="[item.cert_photo]">
				</el-image>
			</div>
			<div class="userdetail_body__view">
				<div class="userdetail_body__view_view">
				</div>
				<p>{{item.cert_type_one_label}}：{{item.major}}</p>
			</div>
			<div class="userdetail_body__view">
				<div class="userdetail_body__view_view">
					<p v-show="item.status_label !='审核中'" @click="editChange(item)">编辑</p>
					<span v-show="item.status_label =='审核中'" style="color: #c22c25;">{{item.status_label}}</span>
				</div>
				<p>发证时间：{{item.cert_time}}</p>
				<span>证书编号：{{item.cert_code}}</span>
			</div>
		</div>
		<!-- 添加证书 -->
		<addCertificate ref="addDialog" @refresh="getCertList"></addCertificate>
	</div>
</template>

<script>
	import navBack from '../../components/navBack.vue'
	import addCertificate from './components/phoneAddCertificate.vue'
	
	import {
		getCertList,
		isCertStatus,
	} from '../../api/moudles/user.js'
	export default {
		data() {
			return {
				certList: [],
			}
		},
		components: {
			addCertificate,
			navBack
		},
		created() {
			this.getCertList()
		},
		methods: {
			addCert() {
				this.$refs.addDialog.openDialog()
			},
			// 编辑
			editChange(item) {
				isCertStatus({
					data: {
						code: item.code
					},
					success: res => {
						if (res.data.info_status == 1) {
							this.$message.warning('证书有待审核中的变更信息')
						} else {
							// this.$refs.addDialog.openDialogChange(item)
						}
					}
				})
			},
			// 获取证书列表
			async getCertList() {
				await getCertList({
					success: res => {
						console.log('证书列表', res)
						this.certList = res.data
						this.$store.dispatch('user/GET_USERINFO')
					}
				})
			},
		}
	}
</script>

<style scoped>
	.userView {
		min-height: 730px;
		background-color: #fff;
		margin-bottom: 20px;
		border: 1px solid #fff;
	}

	.userdetail_title {
		display: flex;
		justify-content: space-between;
		height: 60px;
		font-weight: 500;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #f2f2f2;
	}

	.userdetail_title p {
		font-size: 22px;
	}

	.userdetail_title span {
		cursor: pointer;
	}

	.userdetail_head {
		padding: 20px;
	}

	.userdetail_head p {
		margin: 10px 0;
	}

	.userdetail_head p>span {
		display: inline-block;
		width: 33%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.userdetail_head_form {
		width: 100%;
		display: flex;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
		border: 1px solid #DCDFE6;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.userdetail_body {
		display: flex;
		padding: 20px;
		justify-content: space-between;
		border-bottom: 1px solid #eee;
		box-sizing: border-box;
	}

	.userdetail_head__p {
		display: flex;
		justify-content: space-between;
	}

	.userdetail_body__view {
		width: 33%;
	}

	.userdetail_body__view>span {
		margin-top: 12px;
		display: inline-block;
	}

	.userdetail_body__view p {
		min-height: 20px;
	}

	.userdetail_body__view_view {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		height: 40px;
	}

	.userdetail_body__pspan {
		display: flex;
		width: 100%;
		justify-content: flex-start;
	}

	.userdetail_body__view_view p {
		margin-left: 30px;
		font-size: 15px;
	}
</style>
